import React, { useEffect, useState } from "react";

import axiosOrganizationInstance from "./AxiosOrganizationInstance";
import { getAuthHeaders, getStoredOrganizationId } from "./organizationStorage";

import "./css/today.css"; // Reuse the same CSS file

const History = ({ user_id }) => {
  const [orders, setOrders] = useState([]);
  const [pickupOrders, setPickupOrders] = useState([]);
  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // Default to today's date
  });
  const [activeTab, setActiveTab] = useState("restaurantOrders");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const organizationId = getStoredOrganizationId();

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        setLoading(true);
        setError(null);
        if (!organizationId) {
          throw new Error("Organization not found. Please sign in again.");
        }

        const response = await axiosOrganizationInstance.get(
          `/organization/${organizationId}/orders`,
          {
            headers: getAuthHeaders(),
            params: { selectedDate },
          }
        );
        if (response.data.status === "success") {
          setOrders(response.data.data.orders);
          setPickupOrders(response.data.data.pickup_orders);
        } else {
          throw new Error("Failed to fetch orders and pickup orders");
        }
      } catch (err) {
        console.error(err);
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };
    
  
    fetchOrders();
  }, [organizationId, selectedDate]);
  
  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (error) {
    return <div className="error">Error: {error}</div>;
  }

  return (
    <div className="today-container">
      <div className="today-content">
        {/* <h3 className="headline">Activity History</h3> */}

        
        {/* Tabs */}
        <div className="tabs">
          <button
            className={`tab-button ${activeTab === "restaurantOrders" ? "active" : ""} btn`}
            onClick={() => setActiveTab("restaurantOrders")}
          >
            Orders
          </button>
          <button
            className={`tab-button ${activeTab === "pickupOrders" ? "active" : ""} btn`}
            onClick={() => setActiveTab("pickupOrders")}
          >
            Pickups
          </button>
          {/* Date Selector */}
        <div className="date-selector">
          {/* <label htmlFor="date" className="date-label">Select Date : </label> */}
          <input
          className="date-input"
            type="date"
            id="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            
          />
        </div>

        </div>

        {/* Render Active Tab */}
        {activeTab === "restaurantOrders" && (
          <div className="today-table-container">
            {/* <h4>Restaurant Orders</h4> */}
            {orders.length === 0 ? (
              <p className="nodata">No restaurant orders available for the selected date.</p>
            ) : (
              <table>
                <thead>
                  <tr>
                    <th>Child Name</th>
                    <th>Child Details</th>
                    <th>Delivery Contact Name</th>
                    <th>Delivery Contact No</th>
                    <th>Restaurant Name</th>
                    <th>Food Items</th>
                    <th>Food Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map((order) => (
                    <tr key={order.orderId}>
                      <td>{order.childName || "N/A"}</td>
                      <td>{order.childDetails || "N/A"}</td>
                      <td>{order.deliveryContactName || "N/A"}</td>
                      <td>{order.deliveryContactNo || "N/A"}</td>
                      <td>{order.restaurantName || "N/A"}</td>
                      <td>{(order.foodItems || []).join(", ") || "N/A"}</td>
                      <td>{order.foodQuantity || 0}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}

        {activeTab === "pickupOrders" && (
          <div className="today-table-container">
            {/* <h4>ders</h4> */}
            {pickupOrders.length === 0 ? (
              <p className="nodata">No pickup orders available for the selected date.</p>
            ) : (
              <table>
                <thead>
                  <tr>
                    <th>Child Name</th>
                    <th>Child Details</th>
                    <th>Delivery Contact Name</th>
                    <th>Delivery Contact No</th>
                    <th>Restaurant Name</th>
                    <th>Food Items</th>
                    <th>Food Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {pickupOrders.map((pickup) => (
                    <tr key={pickup.pickupId}>
                      <td>{pickup.childName || "N/A"}</td>
                      <td>{pickup.childDetails || "N/A"}</td>
                      <td>{pickup.deliveryContactName || "N/A"}</td>
                      <td>{pickup.deliveryContactNo || "N/A"}</td>
                      <td>{pickup.restaurantName || "N/A"}</td>
                      <td>{(pickup.foodItems || []).join(", ") || "N/A"}</td>
                      <td>{pickup.foodQuantity || 0}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default History;
